var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMostProfitWings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 185,
    viewBox: "0 0 289 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99 35.5L71.5 49.5L141 83.5V0C112.2 0 101 23.6667 99 35.5Z",
    fill: "#2B241C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183 35.5L210.5 49.5L141 83.5V0C169.8 0 181 23.6667 183 35.5Z",
    fill: "#2B241C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.59 184.864C165.484 184.917 165.272 184.864 164.972 184.811C164.972 184.811 164.937 184.811 164.919 184.811C161.563 183.98 144.375 176.446 144.375 176.446V163.696C147.855 163.696 165.59 160.23 165.59 160.23L165.678 162.459C165.678 162.459 165.678 162.618 165.678 162.689C165.943 168.842 166.473 184.475 165.59 184.882V184.864Z",
    fill: "url(#paint0_linear_5363_51103)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.919 184.81C161.563 183.979 144.675 176.445 144.675 176.445L144.375 163.695H147.837C147.837 163.695 153.313 179.54 164.901 184.792L164.919 184.81Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.632 171.602C147.993 164.157 160.588 164.157 162.779 168.772C164.969 173.388 163.838 184.281 163.838 184.281C163.838 184.281 155.183 178.923 151.615 171.619L151.632 171.602Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149.992 168.613C149.992 168.613 150.398 175.669 152.147 178.534C153.896 181.381 163.311 184.281 163.311 184.281C163.311 184.281 154.514 178.516 149.992 168.631V168.613Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.78
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M165.693 162.671L165.551 160.761C157.761 163.467 147.852 163.696 147.852 163.696C151.331 163.696 165.604 160.23 165.604 160.23L165.569 160.761L165.71 162.671H165.693Z",
    fill: "#BE2F55"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.18 166.898C149.18 166.898 157.093 179.206 163.859 184.264C163.859 184.264 152.801 177.456 149.18 166.898Z",
    fill: "#FFAB34"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.374 163.699V176.448C144.374 176.448 127.698 183.982 124.36 184.813C124.36 184.813 124.325 184.813 124.307 184.813C123.989 184.884 123.795 184.919 123.689 184.866C122.805 184.442 123.335 168.827 123.6 162.673C123.6 162.602 123.6 162.514 123.6 162.443L123.689 160.215C123.689 160.215 140.894 163.681 144.392 163.681L144.374 163.699Z",
    fill: "url(#paint1_linear_5363_51103)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.359 184.81C127.716 183.979 144.674 176.445 144.674 176.445L144.373 163.695H141.423C141.423 163.695 135.947 179.54 124.359 184.792V184.81Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M137.642 171.602C141.281 164.157 128.686 164.157 126.496 168.772C124.306 173.388 125.436 184.281 125.436 184.281C125.436 184.281 134.092 178.923 137.66 171.619L137.642 171.602Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M139.268 168.613C139.268 168.613 138.862 175.669 137.113 178.534C135.364 181.399 125.949 184.281 125.949 184.281C125.949 184.281 134.746 178.516 139.268 168.631V168.613Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.78
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M141.421 163.699C141.421 163.699 131.441 163.787 123.633 161.081L123.562 162.673V162.443L123.668 160.215C123.668 160.215 137.924 163.681 141.421 163.681V163.699Z",
    fill: "#BE2F55"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M140.097 166.898C140.097 166.898 132.184 179.206 125.418 184.264C125.418 184.264 136.476 177.456 140.097 166.898Z",
    fill: "#FFAB34"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.923 136.189C41.9229 147.389 60.7559 159.855 69.4224 164.689L117 65.0002C113.167 62.5003 56.7227 36.8912 35.923 29.6914C9.92352 20.6916 5.92351 36.6912 0.923609 42.1911C-4.07629 47.691 12.9235 87.1902 11.4235 97.69C9.92357 108.19 28.4232 122.19 35.923 136.189Z",
    fill: "#2B241C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M252.917 136.189C246.917 147.389 228.084 159.855 219.417 164.689L183.998 59C187.831 56.5001 232.117 36.8912 252.917 29.6914C278.916 20.6916 282.916 36.6912 287.916 42.1911C292.916 47.691 275.916 87.1902 277.416 97.69C278.916 108.19 260.417 122.19 252.917 136.189Z",
    fill: "#2B241C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M202.434 132.379C202.434 113.775 202.434 95.1721 202.434 76.5865C202.434 73.0851 201.391 69.4246 199.13 67.055C183.904 54.7825 169.083 43.465 149.316 39.5038C146.172 38.655 142.551 38.655 139.406 39.5038C119.64 43.465 104.837 54.8002 89.5923 67.055C87.3313 69.4246 86.2891 73.0851 86.2891 76.5865V132.379C86.2891 135.88 87.3313 139.541 89.5923 141.91C104.819 154.183 119.64 165.5 139.406 169.461C142.551 170.31 146.172 170.31 149.316 169.461C169.083 165.5 183.886 154.165 199.13 141.91C201.391 139.541 202.434 135.88 202.434 132.379Z",
    fill: "#FEA338"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M194.627 80.335V128.629C194.627 129.001 194.627 129.354 194.591 129.726C194.397 132.414 193.496 135.084 191.765 136.887C178.587 147.498 165.763 157.312 148.646 160.725C145.943 161.468 142.799 161.468 140.079 160.725C122.979 157.312 110.155 147.498 96.9593 136.887C94.9985 134.836 94.0977 131.671 94.0977 128.629V80.335C94.0977 77.3111 94.9985 74.128 96.9593 72.0767C110.137 61.4665 122.962 51.6697 140.079 48.2391C142.799 47.5141 145.943 47.5141 148.646 48.2391C165.745 51.6697 178.57 61.4665 191.765 72.0767C193.726 74.128 194.627 77.3111 194.627 80.335Z",
    fill: "url(#paint2_linear_5363_51103)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1231 71.3542C87.1231 71.3542 92.2989 73.883 94.1183 73.6531C95.9378 73.4409 127.186 47.6757 144.374 47.6757C161.562 47.6757 189.101 70.8237 191.768 72.0792C194.435 73.3348 199.876 67.9413 199.876 67.9413C199.876 67.9413 165.625 38.8516 144.356 38.8516C123.088 38.8516 87.7414 68.684 87.1055 71.3542H87.1231Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M194.591 129.725C194.397 132.413 193.496 135.083 191.765 136.887C178.587 147.497 165.763 157.312 148.646 160.725C145.943 161.468 142.799 161.468 140.079 160.725C122.979 157.312 110.155 147.497 96.9593 136.887C94.9985 134.836 94.0977 131.671 94.0977 128.629C94.0977 128.629 115.878 158.727 143.488 158.727C171.098 158.727 194.574 129.725 194.574 129.725H194.591Z",
    fill: "#505050"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M145.451 170.115C140.682 168.435 142.801 164.438 148.083 162.033C153.347 159.611 162.515 157.772 172.089 151.264C181.681 144.756 189.983 137.347 192.615 137.683C195.247 138.019 195.813 144.58 195.813 144.58C195.813 144.58 171.736 167.038 145.433 170.132L145.451 170.115Z",
    fill: "#BE2F55"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0968 73.0688C91.3794 74.3598 101.272 66.8265 110.281 61.5391C119.289 56.2516 119.395 47.1445 119.395 47.1445C119.395 47.1445 88.6767 61.7336 91.0968 73.0688Z",
    fill: "#FFF9C7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M102.98 116.973C104.252 118.723 105.612 120.421 107.026 122.066C108.403 123.728 109.834 125.355 111.336 126.911C114.303 130.041 117.395 133.083 120.804 135.7C124.178 138.37 127.746 140.81 131.668 142.596C135.572 144.365 139.758 145.567 144.104 145.832C139.758 145.903 135.43 144.913 131.403 143.233C127.358 141.535 123.736 139.042 120.274 136.407C116.865 133.684 113.738 130.624 110.859 127.371C107.98 124.117 105.312 120.669 103.016 116.99L102.98 116.973Z",
    fill: "#A8A8A8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M114.213 134.639C117.251 137.698 120.343 140.687 123.699 143.304C125.359 144.63 127.126 145.85 128.981 146.858C130.835 147.866 132.831 148.697 134.987 148.91C132.814 149.051 130.641 148.361 128.68 147.459C126.684 146.558 124.865 145.32 123.151 143.993C121.455 142.649 119.83 141.199 118.346 139.608C116.863 138.034 115.432 136.407 114.195 134.621L114.213 134.639Z",
    fill: "#A8A8A8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M123.848 79.2033C130.03 74.7293 136.672 70.8566 143.756 67.9211C147.289 66.4534 150.98 65.2862 154.778 64.6319C158.559 63.9953 162.551 63.8892 166.296 65.074C170.041 66.2412 173.273 68.9114 175.199 72.289C177.142 75.6666 178.166 79.4686 178.661 83.2706C179.597 90.9276 178.784 98.6023 177.566 106.136L178.166 100.441C178.361 98.5493 178.378 96.6394 178.484 94.7296C178.608 92.8375 178.484 90.9276 178.484 89.0178C178.378 87.1256 178.219 85.2335 177.972 83.359C177.389 79.6277 176.4 75.9141 174.492 72.6957C172.602 69.4773 169.564 66.9839 166.013 65.9052C162.462 64.7557 158.612 64.8088 154.902 65.41C151.175 66.0113 147.554 67.1784 144.003 68.54C140.47 69.9194 137.025 71.5463 133.669 73.35C130.313 75.1361 127.01 77.0636 123.848 79.1856V79.2033Z",
    fill: "#A8A8A8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M102.887 117.504C104.141 119.255 105.501 120.917 106.897 122.544C108.274 124.188 109.688 125.815 111.171 127.354C114.121 130.448 117.177 133.472 120.569 136.089C123.908 138.742 127.458 141.165 131.327 142.968C135.195 144.737 139.346 145.957 143.657 146.222C139.346 146.293 135.054 145.285 131.062 143.587C127.052 141.89 123.448 139.414 120.021 136.779C116.63 134.074 113.538 131.032 110.677 127.814C107.815 124.577 105.165 121.147 102.887 117.504Z",
    fill: "#282828"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M114.055 135.012C117.075 138.053 120.149 141.006 123.488 143.624C125.148 144.95 126.879 146.152 128.734 147.16C130.571 148.168 132.55 149 134.687 149.229C132.514 149.371 130.377 148.681 128.416 147.779C126.438 146.877 124.636 145.657 122.94 144.331C121.244 142.987 119.637 141.555 118.171 139.981C116.687 138.425 115.291 136.798 114.055 135.029V135.012Z",
    fill: "#282828"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M123.527 80.2486C129.657 75.6155 136.264 71.5482 143.347 68.4536C146.88 66.8974 150.572 65.6418 154.387 64.9168C158.185 64.2095 162.23 64.068 165.993 65.3059C169.773 66.526 172.917 69.3731 174.719 72.8568C176.556 76.3405 177.404 80.1955 177.881 84.0329C178.623 91.7607 177.775 99.4885 176.521 107.075L177.157 101.345C177.369 99.4354 177.404 97.5079 177.528 95.598C177.687 93.6882 177.563 91.7607 177.599 89.8508C177.581 87.941 177.351 86.0312 177.21 84.1213C176.645 80.3547 175.832 76.5881 174.03 73.2458C172.264 69.9213 169.296 67.2864 165.728 66.1547C162.177 64.9522 158.274 65.0406 154.546 65.7126C150.801 66.3846 147.163 67.6401 143.63 69.0725C140.097 70.5402 136.652 72.2556 133.314 74.1477C129.957 76.0222 126.689 78.0381 123.545 80.2486H123.527Z",
    fill: "#282828"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M238.436 91.0001C229.215 97.3662 198.938 98.3565 198.938 98.3565V72.7859C198.938 72.7859 249.052 49.355 251.013 50.6282C252.991 51.9191 247.621 84.634 238.436 91.0001Z",
    fill: "#FEA338"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M238.436 90.9969C229.215 97.363 198.938 98.3533 198.938 98.3533V93.0482C198.938 93.0482 227.801 86.965 232.853 81.041C237.888 75.1346 251.03 50.625 251.03 50.625C253.009 51.9159 247.639 84.6308 238.453 90.9969H238.436Z",
    fill: "#BE2F55"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M231.529 117.7C225.24 119.22 198.938 117.7 198.938 117.7V96.5322C198.938 96.5322 245.166 83.8353 248.999 86.8769C249.123 86.9476 249.193 87.0537 249.229 87.1598C250.147 89.6355 240.061 115.648 231.529 117.717V117.7Z",
    fill: "#FEA338"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M231.529 117.7C225.24 119.221 198.938 117.7 198.938 117.7V113.137C198.938 113.137 215.631 113.438 226.6 109.919C235.327 107.125 246.155 91.0858 249.017 86.8594C249.14 86.9301 249.211 87.0362 249.246 87.1423C250.165 89.618 240.078 115.631 231.546 117.7H231.529Z",
    fill: "#BE2F55"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M197.562 135.546C197.562 135.546 197.898 133.07 198.198 129.675C198.569 126.05 198.923 121.399 198.923 117.685C198.923 117.685 222.646 117.066 223.635 117.685C224.625 118.304 216.835 137.915 197.562 135.546Z",
    fill: "#FEA338"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M197.562 135.546C197.562 135.546 197.898 133.07 198.198 129.675L198.923 128.915C198.923 128.915 216.393 127.801 223.635 117.703C224.625 118.322 216.835 137.933 197.562 135.564V135.546Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M198.94 96.517L198.816 93.723C198.816 93.723 225.437 85.6592 230.542 84.1738C235.629 82.6884 242.448 86.3135 242.448 86.3135C242.448 86.3135 226.991 88.2941 198.94 96.517Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M198.94 117.702V113.14C198.94 113.14 219.819 111.99 224.112 111.831C228.404 111.672 231.531 117.702 231.531 117.702L224.112 118.339L223.635 117.702H198.922H198.94Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M213.973 92.3783C206.66 94.3589 217.841 107.71 225.172 108.364C232.503 109.019 245.009 91.8478 246.317 89.1422C247.624 86.4366 223.865 89.6904 213.973 92.3607V92.3783Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M216.091 64.9143C213.158 66.6473 203.584 86.0817 203.672 89.1587C203.761 92.2357 226.583 87.019 233.738 79.9278C240.892 72.8366 247.304 54.0742 247.304 54.0742C247.304 54.0742 230.222 56.5146 216.091 64.9143Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M208.195 117.915C199.115 120.213 200.21 127.092 200.475 128.065C200.74 129.038 210.527 127.499 215.243 124.511C219.959 121.522 223.139 118.374 223.139 118.374C223.139 118.374 211.074 117.19 208.195 117.915Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M247.639 93.846C248.169 91.8831 240.397 100.354 239.407 103.873C238.418 107.374 239.778 109.938 239.778 109.938C239.778 109.938 246.014 99.9823 247.639 93.8637V93.846Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M251.244 55.9669C249.725 55.2772 245.203 80.6887 245.203 80.6887C245.203 80.6887 250.149 68.823 251.244 55.9669Z",
    fill: "white"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M202.293 92.3058C202.293 92.3058 225.487 84.7372 230.98 80.6876C236.456 76.638 244.918 61.6953 244.918 61.6953C244.918 61.6953 236.35 79.0784 230.821 82.7389C225.292 86.3995 202.293 92.3235 202.293 92.3235V92.3058Z",
    fill: "#FFD134"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M198.938 113.139C198.938 113.139 218.386 111.017 225.487 109.036C232.589 107.056 243.099 95.1016 243.099 95.1016C243.099 95.1016 233.083 108.134 226.759 110.592C220.435 113.068 198.938 113.121 198.938 113.121V113.139Z",
    fill: "#FFAB34"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M198.391 127.781C198.391 127.781 205.227 127.197 211.321 125.5C217.398 123.802 220.648 120.973 220.648 120.973C220.648 120.973 211.233 129.213 198.408 129.107V127.781H198.391Z",
    fill: "#FFAB34"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M226.371 83.8197C223.315 84.0673 224.728 77.2768 230.645 75.42C236.563 73.5632 233.719 83.2362 226.371 83.8197Z",
    fill: "#FFF9C7"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4076 90.9988C58.6285 97.3649 88.9056 98.3552 88.9056 98.3552V72.7846C88.9056 72.7846 38.7912 49.3713 36.8304 50.6269C34.852 51.9178 40.222 84.6326 49.4076 90.9988Z",
    fill: "#FEA338"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4076 90.9969C58.6285 97.363 88.9056 98.3533 88.9056 98.3533V93.0482C88.9056 93.0482 60.0417 86.965 54.9896 81.041C49.9729 75.1346 36.8304 50.625 36.8304 50.625C34.852 51.9159 40.222 84.6308 49.4076 90.9969Z",
    fill: "#BE2F55"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M56.317 117.701C62.6055 119.222 88.9081 117.701 88.9081 117.701V96.5337C88.9081 96.5337 42.6799 83.8191 38.8467 86.8607C38.723 86.9314 38.6524 87.0375 38.617 87.1436C37.6985 89.6193 47.785 115.632 56.317 117.701Z",
    fill: "#FEA338"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3151 117.7C62.6037 119.221 88.9062 117.7 88.9062 117.7V113.137C88.9062 113.137 72.2132 113.438 61.2435 109.919C52.5172 107.125 41.6888 91.0858 38.8272 86.8594C38.7035 86.9301 38.6328 87.0362 38.5975 87.1423C37.679 89.618 47.7654 115.631 56.2974 117.7H56.3151Z",
    fill: "#BE2F55"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2849 135.546C90.2849 135.546 89.9493 133.07 89.649 129.675C89.2781 126.05 88.9248 121.399 88.9248 117.685C88.9248 117.685 65.2012 117.066 64.212 117.685C63.2228 118.304 71.0129 137.915 90.2849 135.546Z",
    fill: "#FEA338"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2849 135.546C90.2849 135.546 89.9493 133.07 89.649 129.675L88.9248 128.915C88.9248 128.915 71.4545 127.801 64.212 117.703C63.2228 118.322 71.0129 137.933 90.2849 135.564V135.546Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9219 96.517L89.0456 93.723C89.0456 93.723 62.4251 85.6592 57.32 84.1738C52.2326 82.6884 45.4141 86.3135 45.4141 86.3135C45.4141 86.3135 60.8706 88.2941 88.9219 96.517Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9232 117.702V113.14C88.9232 113.14 68.0436 111.99 63.7512 111.831C59.4587 111.672 56.332 117.702 56.332 117.702L63.7512 118.339L64.2281 117.702H88.9408H88.9232Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8722 92.3783C81.1854 94.3589 70.0037 107.71 62.6729 108.364C55.3421 109.019 42.8356 91.8478 41.5284 89.1422C40.2212 86.4366 63.9801 89.6904 73.8722 92.3607V92.3783Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7719 64.9143C74.7042 66.6473 84.2784 86.0817 84.1901 89.1587C84.1018 92.2357 61.2791 87.019 54.125 79.9278C46.9708 72.8366 40.5586 54.0742 40.5586 54.0742C40.5586 54.0742 57.6402 56.5146 71.7719 64.9143Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6669 117.915C88.7465 120.213 87.6513 127.092 87.3863 128.065C87.1213 129.038 77.3352 127.499 72.6187 124.511C67.9023 121.522 64.7227 118.374 64.7227 118.374C64.7227 118.374 76.7876 117.19 79.6669 117.915Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2056 93.846C39.6756 91.8831 47.448 100.354 48.4373 103.873C49.4265 107.374 48.0663 109.938 48.0663 109.938C48.0663 109.938 41.8307 99.9823 40.2056 93.8637V93.846Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6016 55.9669C38.1207 55.2772 42.6428 80.6887 42.6428 80.6887C42.6428 80.6887 37.6968 68.823 36.6016 55.9669Z",
    fill: "white"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5504 92.3058C85.5504 92.3058 62.3568 84.7372 56.8631 80.6876C51.3695 76.638 42.9258 61.6953 42.9258 61.6953C42.9258 61.6953 51.4931 79.0784 57.0221 82.7389C62.5511 86.3995 85.5504 92.3235 85.5504 92.3235V92.3058Z",
    fill: "#FFD134"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9232 113.139C88.9232 113.139 69.4745 111.017 62.3733 109.036C55.2721 107.056 44.7617 95.1016 44.7617 95.1016C44.7617 95.1016 54.7775 108.134 61.1015 110.592C67.4254 113.068 88.9232 113.121 88.9232 113.121V113.139Z",
    fill: "#FFAB34"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4722 127.781C89.4722 127.781 82.636 127.197 76.5417 125.5C70.4651 123.802 67.2148 120.973 67.2148 120.973C67.2148 120.973 76.6301 129.213 89.4545 129.107V127.781H89.4722Z",
    fill: "#FFAB34"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4724 83.8197C64.5284 84.0673 63.1152 77.2768 57.1976 75.42C51.2799 73.5632 54.1239 83.2362 61.4724 83.8197Z",
    fill: "#FFF9C7"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M244.442 60.6031C241.704 59.8427 238.065 65.2716 240.132 69.6395C242.163 73.9366 250.678 62.3361 244.442 60.6031Z",
    fill: "url(#paint3_linear_5363_51103)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M240.291 64.4747C240.114 67.7108 244.195 67.7816 245.714 66.0663C247.233 64.3332 247.092 60.5312 244.071 60.5312C241.051 60.5312 240.273 64.4747 240.273 64.4747H240.291Z",
    fill: "#BE2F55"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M239.531 67.2835C240.361 65.3206 242.817 67.6372 244.283 67.7079C245.749 67.7787 243.311 71.0148 241.616 70.5904C239.92 70.166 239.531 67.2835 239.531 67.2835Z",
    fill: "#FFDE00"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M105.9 73.6169C106.271 80.4251 114.662 75.0139 115.21 69.7972C115.775 64.3153 105.53 66.5434 105.9 73.6169Z",
    fill: "#C4C4C4",
    fillOpacity: 0.25
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M49.1594 67.692C52.0564 64.7919 59.0515 67.0731 64.7572 72.8026C70.4805 78.5321 72.7593 85.5172 69.8623 88.4173C66.9653 91.3174 59.9701 89.0362 54.2644 83.3067C48.5411 77.5772 46.2624 70.5921 49.1594 67.692Z",
    fill: "url(#paint4_radial_5363_51103)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M212.716 111.689C211.621 108.771 215.401 104.669 221.16 102.511C226.901 100.372 232.448 100.99 233.543 103.908C234.638 106.826 230.858 110.929 225.099 113.086C219.358 115.226 213.811 114.607 212.716 111.689Z",
    fill: "url(#paint5_radial_5363_51103)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M158.168 43.5903C159.723 41.2207 165.004 41.9634 169.968 45.2349C174.932 48.5064 177.687 53.0687 176.133 55.4384C174.578 57.808 169.297 57.0653 164.333 53.7938C159.369 50.5223 156.614 45.9599 158.168 43.5903Z",
    fill: "url(#paint6_radial_5363_51103)"
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M169.598 41.7495C164.493 43.1642 159.865 49.5126 159.865 49.5126C148.1 42.9873 132.538 46.6125 125.772 49.5126C125.772 49.5126 121.144 43.1642 116.039 41.7495C116.039 41.7495 123.388 15.0117 142.801 15.0117C162.214 15.0117 169.58 41.7495 169.58 41.7495H169.598Z",
    fill: "url(#paint7_linear_5363_51103)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M122.946 36.5163C123.035 37.8956 132.997 42.9886 142.819 42.9886C152.641 42.9886 162.285 38.7091 162.939 37.8249C163.593 36.9407 156.138 19.0625 143.508 19.0625C130.878 19.0625 122.84 34.854 122.946 36.4986V36.5163Z",
    fill: "url(#paint8_linear_5363_51103)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M126.938 35.4175C127.009 36.5139 134.976 40.5988 142.854 40.5988C150.733 40.5988 158.452 37.1682 158.964 36.4608C159.494 35.7535 153.524 21.4297 143.402 21.4297C133.28 21.4297 126.85 34.0735 126.938 35.3998V35.4175Z",
    fill: "url(#paint9_linear_5363_51103)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.78
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M124.625 32.5729C124.625 32.5729 133.952 22.6346 142.82 22.6346C151.687 22.6346 161.35 33.2271 161.35 33.2271C161.35 33.2271 153.754 19.0625 143.508 19.0625C133.263 19.0625 124.625 32.5729 124.625 32.5729Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M128.42 35.2969C127.608 34.7311 137.959 32.1846 144.972 32.2554C151.985 32.3261 156.312 35.0494 156.701 36.2872C157.09 37.5251 140.697 43.7498 128.438 35.2969H128.42Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.89
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M134.022 26.9663C129.889 31.3872 138.297 32.0061 144.374 31.6878C150.45 31.3518 151.687 26.0998 151.457 25.3217C151.228 24.5613 140.7 19.8044 134.022 26.9663Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M169.598 41.7487C164.493 43.1634 159.865 49.5118 159.865 49.5118C145.61 45.869 142.536 47.6904 125.772 49.5118C125.772 49.5118 121.144 43.1634 116.039 41.7487C116.039 41.7487 118.07 38.8132 122.504 39.6443C126.938 40.4754 133.032 45.3208 142.801 45.25C152.587 45.1616 161.19 37.8406 169.58 41.7487H169.598Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M119.906 32.2717C119.906 32.2717 130.187 20.1053 141.987 19.1858C153.787 18.2485 162.972 32.2717 162.972 32.2717C162.972 32.2717 158.503 14.4642 142.8 15.0124C127.096 15.5606 119.906 32.2717 119.906 32.2717Z",
    fill: "white"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M149.549 16.9562C146.846 17.1861 153.664 22.9864 155.219 23.623C156.773 24.2596 155.307 16.4611 149.549 16.9562Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M126.371 47.461C126.371 50.538 123.88 53.0314 120.807 53.0314C117.733 53.0314 115.242 50.538 115.242 47.461C115.242 44.384 117.733 41.8906 120.807 41.8906C123.88 41.8906 126.371 44.384 126.371 47.461Z",
    fill: "url(#paint10_radial_5363_51103)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M122.785 47.461C122.785 48.5574 121.902 49.4416 120.807 49.4416C119.711 49.4416 118.828 48.5574 118.828 47.461C118.828 46.3647 119.711 45.4805 120.807 45.4805C121.902 45.4805 122.785 46.3647 122.785 47.461Z",
    fill: "url(#paint11_radial_5363_51103)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M157.745 41.9251C159.16 41.9251 160.306 40.7771 160.306 39.361C160.306 37.9449 159.16 36.7969 157.745 36.7969C156.33 36.7969 155.184 37.9449 155.184 39.361C155.184 40.7771 156.33 41.9251 157.745 41.9251Z",
    fill: "url(#paint12_radial_5363_51103)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M157.745 40.2647C158.242 40.2647 158.646 39.8609 158.646 39.3628C158.646 38.8647 158.242 38.4609 157.745 38.4609C157.247 38.4609 156.844 38.8647 156.844 39.3628C156.844 39.8609 157.247 40.2647 157.745 40.2647Z",
    fill: "url(#paint13_radial_5363_51103)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5363_51103",
    x1: 155.221,
    y1: 184.899,
    x2: 155.221,
    y2: 160.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B93E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5363_51103",
    x1: 133.775,
    y1: 184.901,
    x2: 133.775,
    y2: 160.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B93E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5363_51103",
    x1: 188.918,
    y1: 160.996,
    x2: 144.371,
    y2: 47.6909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#535353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5363_51103",
    x1: 243.1,
    y1: 70.5944,
    x2: 243.1,
    y2: 60.5324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FFA200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#D36500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BC4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A92C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#9D1A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#951000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#930D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_5363_51103",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.4085 77.2866) rotate(-134.969) scale(14.5833 7.49419)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A68F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_5363_51103",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(222.487 98.2704) rotate(159.53) scale(11.0665 5.69163)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A68F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_5363_51103",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.062 50.03) rotate(-146.602) scale(10.7761 5.11811)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A68F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5363_51103",
    x1: 142.819,
    y1: 49.5126,
    x2: 142.819,
    y2: 15.0117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B93E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5363_51103",
    x1: 142.96,
    y1: 42.9886,
    x2: 142.96,
    y2: 19.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFA200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ED8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#CA6200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#AF4200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9C2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#901C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8D1800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#951F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#A42E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#AD3600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B03900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5363_51103",
    x1: 142.96,
    y1: 40.5988,
    x2: 142.96,
    y2: 21.4474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#015E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0393B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#05ABCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#06A1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#07C9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0786FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#086BFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_5363_51103",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.824 45.9459) scale(5.26404 5.11165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#950059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_5363_51103",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.824 45.6495) scale(1.76646 1.69764)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FF009D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_5363_51103",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(157.745 37.8659) scale(2.43771 2.36714)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#950059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_5363_51103",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(157.745 37.5867) scale(0.812574 0.780911)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FF009D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMostProfitWings);
export default __webpack_public_path__ + "static/media/mostProfitWings.97e6270bbbfb64e81e635fe7158f7bf2.svg";
export { ForwardRef as ReactComponent };